export const apiUrl = "https://glpdemoproject-056f5c4b4508.herokuapp.com/api/"
// export const apiUrl = "https://localhost:44350/api/"
export default apiUrl;
